// Entry times are stored as ISO-8601 UTC and edited as local date-times (SPEC.md §4.2).
import { addDays, format, parse, startOfDay } from 'date-fns';

/** Value for <input type="datetime-local"> from a stored ISO time (or now). */
export function toLocalInput(iso?: string | null) {
  return format(iso ? new Date(iso) : new Date(), "yyyy-MM-dd'T'HH:mm");
}

/** ISO UTC time from a datetime-local value; null when it isn't a valid date-time. */
export function fromLocalInput(value: string): string | null {
  const date = parse(value, "yyyy-MM-dd'T'HH:mm", new Date());
  return Number.isNaN(date.getTime()) ? null : date.toISOString();
}

/** [start, end) of a local calendar day as ISO UTC, for range queries on stored times. */
export function dayRange(day: Date = new Date()): [string, string] {
  const start = startOfDay(day);
  return [start.toISOString(), addDays(start, 1).toISOString()];
}

/** Local calendar date 'yyyy-MM-dd' of a stored ISO time. */
export const localDateOf = (iso: string) => format(new Date(iso), 'yyyy-MM-dd');
